import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { IPart } from "../models/Part";

export interface IPartDetailsResponse extends DefaultResponseWithData<IPart> {}

export default function usePartDetails(partId: string | undefined, enabled: boolean = true) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60 * 5; // 5 minutes - cache for a bit to avoid refetching when collapsing/expanding

  const partDetails = useQuery({
    queryKey: ["partDetails", partId],
    queryFn: () => {
      return get<IPartDetailsResponse>(`/part/details/${partId}`);
    },
    enabled: enabled && !!partId,
    staleTime: staleTime,
    retry: 1,
  });

  return {
    partDetails: partDetails.data?.data,
    isLoading: partDetails.isLoading,
    isError: partDetails.isError,
    error: partDetails.error,
  };
}
